module.exports = __webpack_public_path__ + "img/night-bg.b5a6e004.png";